export default __webpack_public_path__ + "img/password-icon.svg";